module.exports = __webpack_public_path__ + "static/media/CSIRO_Logo.svg.40b9dab3.png";